import { message } from 'antd'
import { lazy } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import './App.less'
import SuspenseRoute from './components/suspense-route'
import { useShouldReload } from './hooks/useShouldReload'

const ProtectedRoute = lazy(() => import('./components/protected-route'))
const HomePage = lazy(() => import('./pages/home/homepage'))
const Cart = lazy(() => import('./pages/home/cart'))
const Topup = lazy(() => import('./pages/home/topup'))
const SearchPage = lazy(() => import('./pages/home/searchpage'))
const PayDoneList = lazy(() => import('./pages/home/paydone-list'))
const Recharge = lazy(() => import('./pages/recharge'))
const Unpaid = lazy(() => import('./pages/unpaid'))
const Cancelled = lazy(() => import('./pages/cancelled'))

const Login = lazy(() => import('./pages/login'))
const RechargeSuccess = lazy(() => import('./pages/recharge/success'))

const MOBILE_BREAKPOINT = 768
const MOBILE_MESSAGE_TOP = window.innerHeight / 3 - 40
const DESKTOP_MESSAGE_TOP = 16
const MAX_MESSAGE_COUNT = 3

message.config({
  top: window.innerWidth <= MOBILE_BREAKPOINT ? MOBILE_MESSAGE_TOP : DESKTOP_MESSAGE_TOP,
  maxCount: MAX_MESSAGE_COUNT,
})

export default function App() {
  const { isReloading } = useShouldReload()

  if (isReloading) return null

  return (
    <BrowserRouter>
      <Routes>
        {/* 需要登录才能查看的路由 */}
        <Route
          path="/"
          element={
            <SuspenseRoute>
              <ProtectedRoute />
            </SuspenseRoute>
          }
        >
          <Route index element={<Navigate to="homepage" replace />} />
          <Route
            path="homepage"
            element={
              <SuspenseRoute>
                <HomePage />
              </SuspenseRoute>
            }
          />
          <Route
            path="cart"
            element={
              <SuspenseRoute>
                <Cart />
              </SuspenseRoute>
            }
          />
          <Route
            path="top-up"
            element={
              <SuspenseRoute>
                <Topup />
              </SuspenseRoute>
            }
          />
          <Route
            path="search-page"
            element={
              <SuspenseRoute>
                <SearchPage />
              </SuspenseRoute>
            }
          />
          <Route
            path="paydone-list"
            element={
              <SuspenseRoute>
                <PayDoneList />
              </SuspenseRoute>
            }
          />
          <Route
            path="recharge"
            element={
              <SuspenseRoute>
                <Recharge />
              </SuspenseRoute>
            }
          />
          <Route
            path="unpaid"
            element={
              <SuspenseRoute>
                <Unpaid />
              </SuspenseRoute>
            }
          />
          <Route
            path="cancelled"
            element={
              <SuspenseRoute>
                <Cancelled />
              </SuspenseRoute>
            }
          />
        </Route>

        {/* 不需要登录权限的路由 */}
        <Route
          path="/login"
          element={
            <SuspenseRoute>
              <div className="App">
                <Login />
              </div>
            </SuspenseRoute>
          }
        />
        <Route
          path="/recharge/success"
          element={
            <SuspenseRoute>
              <RechargeSuccess />
            </SuspenseRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
